import { makeQueue } from './queue';

export const EVENTS = {
    jobApplySuccess: 'job_apply_success',
    funnel: 'funnel',
    userdata: 'userdata',
    trackVisibility: 'show_element',
    pageView: 'pageview',
};

export const FUNNEL_TYPES = {
    application: 'Application',
};

export const FUNNEL_STEP = {
    form: 'Form',
    customFields: 'Custom Fields',
    success: 'Success',
};

export const FUNNEL_VARIANTS = {
    guest: 'guest',
    registered: 'registered',
};

/**
 * Event
 * @typedef {object} Event
 * @property {string} [event]
 * @property {string} [category]
 * @property {string} [action]
 * @property {string} [label]
 * @property {string} [nonInteraction]
 * @property {string} [funnelType]
 * @property {string} [funnelStep]
 * @property {string} [funnelVariant]
 */

/**
 * GA4 Event
 * @typedef {object} GA4Event
 * @property {string} [element]
 * @property {string} [elementDetail]
 * @property {string} [event]
 * @property {string} [jobId]
 * @property {string} [funnelType]
 * @property {string} [funnelStep]
 */

/**
 * Tracker
 * @typedef {object} Tracker
 * @property {function} enable
 * @property {function} event
 * @property {function} [trackUser]
 * @property {function} [trackVisibility]
 * @property {function} [trackVirtualPageView]
 */

/** @type {Tracker[]} */
const trackers = [];

/**
 * Register tracker.
 *
 * @param {Tracker} tracker
 */
export function registerTracker(tracker) {
    trackers.push(tracker);
}

const eventQueue = makeQueue();

/**
 * Enable trackers.
 *
 * @param {array} dependencies
 */
export function enableTrackers(dependencies) {
    eventQueue.add(() => {
        trackers.forEach((tracker, index) => tracker.enable?.(dependencies[index]));
    });
}

/**
 * Send user data for every tracker.
 */
export function trackUser() {
    eventQueue.add(() => Promise.all(trackers.map(tracker => tracker.trackUser?.())));
}

/**
 * Track events.
 *
 * @param {Event} event
 */
export function track(event) {
    eventQueue.add(() => {
        trackers.forEach(tracker => tracker.event(event));
    });
}

/**
 * Send show_element event for every tracker.
 */
export function trackVisibility({ element, elementDetail }) {
    eventQueue.add(() => {
        trackers.forEach(tracker => tracker.trackVisibility?.({ element, elementDetail }));
    });
}

/**
 * Send page_view event for every tracker.
 */
export function trackVirtualPageView({ pageUrl, pageTitle }) {
    eventQueue.add(() => {
        trackers.forEach(tracker => tracker.trackVirtualPageView?.({ pageUrl, pageTitle }));
    });
}
